import{useContext as o}from"react";import{JobContext as t}from"../context/job-context";function r(){return o(t)}export{r as useJobContext};
